import type { SupportedOnboardingTourStep, UpdateOnboardingTourStepOptionHandler } from 'models';
import { ArrowLeftLineIcon, Button, Col, ProgressIndicator, Row, Text, Title } from 'ui';
import { useNavigateThroughOnboardingTourSteps } from '../../hooks';
import { useSupportedStepDescription, useSupportedStepProgress, useSupportedStepTitle } from './hooks';

type P = {
  onChangeStep: UpdateOnboardingTourStepOptionHandler;
  step: SupportedOnboardingTourStep;
  steps: SupportedOnboardingTourStep[];
};

const StepHeader = ({ onChangeStep, step, steps }: P) => {
  const { onNavigateToPreviousStep } = useNavigateThroughOnboardingTourSteps({ onChangeStep, step: step.step, steps });
  const { current, total } = useSupportedStepProgress({ step, steps });
  const title = useSupportedStepTitle({ step: step.step });
  const description = useSupportedStepDescription({ step: step.step });

  return (
    <Row gutter={[0, 'xxs']}>
      {onNavigateToPreviousStep ? (
        <Col span={24}>
          <Button icon={<ArrowLeftLineIcon />} onClick={onNavigateToPreviousStep} type="link-secondary">
            Back
          </Button>
        </Col>
      ) : null}
      {steps.length > 1 ? (
        <Col span={24}>
          <ProgressIndicator progressProperties={{}} step={current} textProperties={{ size: 'large' }} total={total} />
        </Col>
      ) : null}
      <Col span={24}>
        <Row gutter={[0, 'xl']}>
          <Col span={24}>
            <Title level={2}>{title}</Title>
          </Col>
          <Col span={24}>
            <Text>{description}</Text>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default StepHeader;
